<template lang="pug">
v-container.pa-0(grid-list-xl, fluid)
  v-layout(wrap)
    v-flex(xs6)
      b-text(:block='getBlockByIndex(0)', @update='setBlockByIndex(0, $event)')
    v-flex.lft(xs6)
      b-text(:block='getBlockByIndex(1)', @update='setBlockByIndex(1, $event)')
</template>

<script>
import Text from './Text'
import BaseBlock from './BaseBlock'

export default {
  extends: BaseBlock,

  components: { BText: Text },

  mounted() {},

  methods: {
    setBlockByIndex(index, block) {
      this.block.value[index] = block.value
      this.$emit('update', this.block)
    },

    getBlockByIndex(index) {
      const value = this.block.value[index]
      return { value: value || '', type: 'text' }
    },
  },
}
</script>

<style scoped>
.lft {
  border-left: solid 1px #ccc;
}
</style>
